var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.85156 17.0005L4.4807 8.39606H6.90667L9.53581 17.0005H7.86272L5.5204 9.41186H5.83112L3.52465 17.0005H1.85156ZM3.42904 15.2079V13.6902H7.97028V15.2079H3.42904Z",
    fill: "#A1ABB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1843 8.39606H13.8096L11.515 17.0005H9.88975L12.1843 8.39606Z",
    fill: "#A1ABB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4612 17.1798C17.6008 17.1798 16.8579 16.9925 16.2325 16.6181C15.611 16.2436 15.131 15.7198 14.7924 15.0466C14.4578 14.3734 14.2905 13.5906 14.2905 12.6983C14.2905 11.806 14.4578 11.0232 14.7924 10.35C15.131 9.67676 15.611 9.15293 16.2325 8.77848C16.8579 8.40402 17.6008 8.2168 18.4612 8.2168C19.4492 8.2168 20.2777 8.46178 20.947 8.95176C21.6202 9.44173 22.0942 10.105 22.3691 10.9415L20.7319 11.3957C20.5725 10.8738 20.3036 10.4695 19.9252 10.1827C19.5468 9.89187 19.0588 9.74648 18.4612 9.74648C17.9155 9.74648 17.4594 9.86797 17.0929 10.111C16.7304 10.354 16.4575 10.6966 16.2743 11.1387C16.091 11.5809 15.9994 12.1007 15.9994 12.6983C15.9994 13.2958 16.091 13.8157 16.2743 14.2578C16.4575 14.7 16.7304 15.0426 17.0929 15.2856C17.4594 15.5286 17.9155 15.6501 18.4612 15.6501C19.0588 15.6501 19.5468 15.5047 19.9252 15.2139C20.3036 14.9231 20.5725 14.5188 20.7319 14.0009L22.3691 14.455C22.0942 15.2916 21.6202 15.9548 20.947 16.4448C20.2777 16.9348 19.4492 17.1798 18.4612 17.1798Z",
    fill: "#A1ABB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco9);
export default __webpack_public_path__ + "static/media/ico-9.02ff476e888881ef4a7ca90d13e66ef4.svg";
export { ForwardRef as ReactComponent };